export const formatMXN = (value) => {
  const n = Number(value || 0);
  return `$${n.toLocaleString("es-MX", { minimumFractionDigits: 0, maximumFractionDigits: 2 })} MXN`;
};
